import { useNavigate } from "react-router-dom";
import AppHeader from "./AppHeader.jsx";
import { useAuth } from "../context/AuthContext.jsx";
import { useRole } from "../hooks/useRole.js";
import { performSignOut } from "../lib/authSession.js";
import { navConfigForRole } from "../lib/appNav.js";

export default function RoleAppHeader() {
  const navigate = useNavigate();
  const role = useRole();
  const { clearSession, status } = useAuth();
  const { navItems, homeHref } = navConfigForRole(role);

  async function handleSignOut() {
    await performSignOut({ clearSession, navigate });
  }

  return (
    <AppHeader
      navItems={navItems}
      homeHref={homeHref}
      onSignOut={status === "authenticated" ? handleSignOut : undefined}
    />
  );
}
